'use client'

import { FiltersIconNew } from '@/components/svg/filters-icon-new/filters-icon-new'
import { ButtonV4 } from '@/components/v4/atoms/button/button'
import { useModal } from '@/hooks/use-modal'
import cx from 'classnames'
import s from './supplier-list-filters-btn.module.scss'

export type FiltersTag = {
  id: number
  name: string
}

type Props = {
  allTags: FiltersTag[]
  supplierToTagData?: { supplierId: number; tagId: number }[]
  selectedTags?: number[]
  totalDataCount?: number
  categoryName?: string
  className?: string
}

export const SupplierListFiltersBtn = ({
  allTags,
  supplierToTagData,
  selectedTags,
  totalDataCount,
  className,
  categoryName,
}: Props) => {
  const modal = useModal()

  const handleClick = () => {
    modal.open('supplier-category-filters', {
      modalProps: {
        supplierCategoryFilters: {
          allTags,
          selectedTags,
          supplierToTagData,
          totalDataCount: totalDataCount || 0,
          categoryName: categoryName || '',
        },
      },
    })
  }

  return (
    <ButtonV4
      className={cx(s.button, className)}
      onClick={handleClick}
      variant="dark"
    >
      <FiltersIconNew iconColor="#fff" />
      Filters
      {!!selectedTags?.length && (
        <span className={s.filtersCounter}>{selectedTags?.length}</span>
      )}
    </ButtonV4>
  )
}
